import { SET_CONTRACT } from '../mutation-types'
import AgentApi from '@/api/AgentApi'

const state = {
  currentContract: null
}

const getters = {
  currentContract: (state) => state.currentContract
}

const actions = {

  async getContract ({ state, commit }, { contractId, force }) {
    const isContractFetched = Boolean(state.currentContract)
    const isSameContractFetched = () => `${state.currentContract.id}` === `${contractId}`

    if (isContractFetched && isSameContractFetched() && !force) return { contractId }

    const contract = await AgentApi.getContract(contractId)
    commit(SET_CONTRACT, contract)
    return contract
  }
}

const mutations = {
  [SET_CONTRACT] (state, contract) {
    state.currentContract = contract
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
